import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import { push } from 'connected-react-router'

import { Container } from './layout-style'

import { OrderRoutes } from '@constants/StepOrderEnum'
import RouteEnum from '@constants/RouteEnum'

import * as StepBarSelector from 'selectors/ui/stepbar-selector'
import { lastPathIsEqual } from '@utilities/pathname-utility'

const Layout = ({ children, onChangeStep }) => {
  const dispatch = useDispatch()
  const currentStep = useSelector(StepBarSelector.step)
  const location = useLocation()
  const params = useParams()
  const [currentStepIsValid, setCurrentStepIsValid] = useState(false)

  useEffect(() => {
    if (onChangeStep) onChangeStep(currentStep)
  }, [currentStep])

  useEffect(() => {
    const currentStepIsValid = lastPathIsEqual(OrderRoutes[currentStep], location?.pathname)
    setCurrentStepIsValid(currentStepIsValid)

    if (!currentStepIsValid) {
      dispatch(push(RouteEnum.CompanyStep.replace(':planId', params?.planId)))
    }
  }, [])

  return <Container>{children}</Container>
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  onChangeStep: PropTypes.func,
}

export default Layout
